<!-- 在线监控 -->
<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed ? 0 : 5" :sm="24" class="new-col">
      <a-row :gutter="10" class="new-row">
        <a-card :bordered="false" class="new-tree-card">
          <AreaTreeCard
            ref="areaTreeCard"
            :area-loading="areaLoading"
            :area-tree="areaTree"
            :curr-selected="currSelected"
            @node-selected="handleNodeSelected"
            @node-unselected="handleNodeUnselected"
            @unselect="resetAareaData"
            @collapse-all="collapseTree"
            @area-add="handleAreaAdd"
            @add-child="handleAdd"
            @delete="handleDelete"
            @toggle-visibility="handleTreeToggle"
          />
        </a-card>
      </a-row>
    </a-col>
    <a-col :md="collapsed ? 24 : 19" :sm="24" style="position: relative; padding-left: 30px" class="new-col">
      <a-icon
        :type="collapsed ? 'caret-right' : 'caret-left'"
        @click="collapsed = !collapsed"
        class="area-collapsed"
      ></a-icon>
      <a-card :bordered="false">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane key="1" :tab="$t('流量')">
            <internet-traffic ref="internetTrafficRef"></internet-traffic>
          </a-tab-pane>
          <a-tab-pane key="2" :tab="$t('压力')">
            <pressure ref="pressureRef"></pressure>
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </a-col>
  </a-row>
</template>
  
  <script>
import internetTraffic from './internetTraffic.vue'
import pressure from './pressure.vue'
import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
import AreaTreeCard from '../AreaTreeCard.vue'
export default {
  name: 'onlineMonitor',
  mixins: [AreaChoosetMixin],
  components: {
    AreaTreeCard,
    internetTraffic,
    pressure,
  },
  data() {
    return {
      description: '在线监控',
      activeKey: '1',
      selectedAreaCode: '', // 存储选中的区域代码
      // collapsed, areaTree, areaLoading, currSelected 等已由 AreaChoosetMixin 提供
    }
  },
  mounted() {
    // 初始化加载区域树
    this.loadTree()
  },
  computed: {},
  methods: {
    changeTab(e) {
      // Tab切换时，将当前选择的区域代码传递给新激活的子组件
      this.$nextTick(() => {
        if (e == 2) {
          // 切换到压力Tab
          if (this.$refs.pressureRef) {
            if (this.selectedAreaCode) {
              this.$refs.pressureRef.handleAreaChange(this.selectedAreaCode)
            } else {
              // 如果没有选择区域，也调用一次初始化
              this.$refs.pressureRef.loadData()
            }
          }
        } else {
          // 切换到流量Tab
          if (this.$refs.internetTrafficRef) {
            if (this.selectedAreaCode) {
              this.$refs.internetTrafficRef.handleAreaChange(this.selectedAreaCode)
            } else {
              // 如果没有选择区域，也调用一次初始化
              this.$refs.internetTrafficRef.loadData()
            }
          }
        }
      })
    },
    // 区域树节点选择回调
    handleNodeSelected(record) {
      console.log('选中区域:', record)
      this.selectedAreaCode = record.code || '' // 保存选中的区域代码
      // 通知当前激活的子组件更新数据
      if (this.activeKey === '1' && this.$refs.internetTrafficRef) {
        this.$refs.internetTrafficRef.handleAreaChange(this.selectedAreaCode)
      } else if (this.activeKey === '2' && this.$refs.pressureRef) {
        this.$refs.pressureRef.handleAreaChange(this.selectedAreaCode)
      }
    },
    // 区域树节点取消选择回调
    handleNodeUnselected() {
      console.log('取消选择区域')
      this.selectedAreaCode = ''
      // 通知当前激活的子组件清空区域筛选
      if (this.activeKey === '1' && this.$refs.internetTrafficRef) {
        this.$refs.internetTrafficRef.handleAreaChange('')
      } else if (this.activeKey === '2' && this.$refs.pressureRef) {
        this.$refs.pressureRef.handleAreaChange('')
      }
    },
    // 重置区域数据
    resetAareaData() {
      this.selectedAreaCode = ''
      if (this.activeKey === '1' && this.$refs.internetTrafficRef) {
        this.$refs.internetTrafficRef.handleAreaChange('')
      } else if (this.activeKey === '2' && this.$refs.pressureRef) {
        this.$refs.pressureRef.handleAreaChange('')
      }
    },
    // 以下方法为 AreaTreeCard 组件的事件处理
    handleTreeToggle(visible) {
      this.collapsed = !visible
    },
    handleAreaAdd() {
      this.$message.info(this.$t('添加区域功能待实现'))
    },
    handleAdd(node, data) {
      this.$message.info(this.$t('添加子区域功能待实现'))
    },
    handleDelete(node, data) {
      this.$message.info(this.$t('删除区域功能待实现'))
    },
    collapseTree() {
      // 调用 mixin 中的 collapseAll 方法
      if (this.$refs.areaTreeCard && this.$refs.areaTreeCard.collapseAll) {
        this.$refs.areaTreeCard.collapseAll()
      }
    },
  },
}
</script>
  <style scoped>
@import '~@assets/less/common.less';
</style>